var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14645 6.85355C0.951185 6.65829 0.951185 6.34171 1.14645 6.14645L3.14645 4.14645C3.34171 3.95118 3.65829 3.95118 3.85355 4.14645C4.04882 4.34171 4.04882 4.65829 3.85355 4.85355L2.70711 6L10.5 6C10.7761 6 11 6.22386 11 6.5C11 6.77614 10.7761 7 10.5 7L2.70711 7L3.85355 8.14645C4.04882 8.34171 4.04882 8.65829 3.85355 8.85355C3.65829 9.04882 3.34171 9.04882 3.14645 8.85355L1.14645 6.85355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.ce8cf1e1f3100555059c0bd1cca0dc8a.svg";
export { ForwardRef as ReactComponent };